// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1761":"afbc64b7cd76e9a7","6511":"c35b5a16e27840e5"}[chunkId] + ".js";
};